import { useEffect } from 'react';

function useAutoLogout() {
  useEffect(() => {
    let inactivityInterval;
    inactivityInterval = setInterval(() => {
      const lastTimeActivity = parseInt(localStorage.getItem('lastTimeActivity'));
      if (Date.now() - lastTimeActivity > 900000) {
        localStorage.clear();
        window.location.reload();
      }
    }, 1000);


    function resetTimeout() {
      localStorage.setItem('lastTimeActivity', Date.now());      
    }
    

    resetTimeout();

    window.addEventListener('click', resetTimeout);
    window.addEventListener('mousemove', resetTimeout);
    window.addEventListener('keydown', resetTimeout);

    return () => {
      window.removeEventListener('click', resetTimeout);
      window.removeEventListener('mousemove', resetTimeout);
      window.removeEventListener('keydown', resetTimeout);
      clearInterval(inactivityInterval);
    };
  }, []);
}

export default useAutoLogout;
